import { render, staticRenderFns } from "./qErrors.vue?vue&type=template&id=f2dadef0&scoped=true&"
import script from "./qErrors.vue?vue&type=script&lang=ts&"
export * from "./qErrors.vue?vue&type=script&lang=ts&"
import style0 from "./qErrors.vue?vue&type=style&index=0&id=f2dadef0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dadef0",
  null
  
)

export default component.exports